import { autoRegisterFeature } from '@store/features/factory';

import { ehrExtensionPromoFeature } from './store/feature';

autoRegisterFeature(ehrExtensionPromoFeature);

export type { EhrExtensionPromoState } from './store';
export { dismissPromo, selectShouldShowEhrPromo,snoozePromo } from './store';
